export default "__VITE_ASSET__d2fb7071__"